const SLOT_PX = 56;
const MOBILE_SLOT_PX = 52;
const TIME_VIEW_CHROME_PX = 52 + 72 + 16;
const MONTH_VIEW_HEIGHT_PX = 640;
const VIEWPORT_BOTTOM_RATIO = 0.05;
const VIEWPORT_MIN_PX = 360;

const hourSpan = (min, max) => {
    const start = min.getHours() + min.getMinutes() / 60;
    const end = max.getHours() + max.getMinutes() / 60 + max.getSeconds() / 3600;
    return Math.max(Math.ceil(end - start), 1);
};

/** Altura del Calendar en vista día/semana según el rango horario (sin scroll interno). */
export const getTimeViewCalendarHeight = (min, max, { mobile = false } = {}) => (
    TIME_VIEW_CHROME_PX + hourSpan(min, max) * (mobile ? MOBILE_SLOT_PX : SLOT_PX)
);

export const getMonthViewCalendarHeight = () => MONTH_VIEW_HEIGHT_PX;

/**
 * Piso de altura para llenar el viewport dejando ~5% abajo.
 * `topOffsetPx` es la distancia del panel al borde superior de la ventana.
 */
export const getViewportCalendarMinHeight = (
    topOffsetPx = 0,
    {
        bottomRatio = VIEWPORT_BOTTOM_RATIO,
        minPx = VIEWPORT_MIN_PX,
    } = {},
) => {
    if (typeof window === 'undefined') return minPx;
    const bottomPad = window.innerHeight * bottomRatio;
    const available = window.innerHeight - Math.max(0, topOffsetPx) - bottomPad;
    return Math.max(minPx, Math.round(available));
};

/** @deprecated Prefer getTimeViewCalendarHeight */
export const getMobileDayCalendarHeight = (min, max) => (
    getTimeViewCalendarHeight(min, max, { mobile: true })
);

export const MOBILE_DAY_SLOT_PX = MOBILE_SLOT_PX;
